import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { formatCalendarDay } from '@adornis/datetime/calendarDay.js';
import { format } from 'date-fns';
import type { Contract } from '../entities/Contract.js';

export function getReadableNameForContract(
  contract: NarrowedEntity<Contract, { createdAt: 1; agInfos: { einstellungsdatum: 1; unterzeichnungsdatum: 1 } }>,
) {
  const startDate = contract.agInfos?.einstellungsdatum;
  const signedAt = contract.agInfos?.unterzeichnungsdatum;
  if (startDate)
    return `Vertrag zum ${formatCalendarDay(startDate, 'dd.MM.yyyy')}${
      signedAt ? ` unterzeichnet am ${formatCalendarDay(signedAt, 'dd.MM.yyyy')}` : ', nicht unterzeichnet'
    }`;

  return `Neuer Vertrag erstellt am ${format(contract.createdAt, 'dd.MM.yyyy')}`;
}
